import { createFileRoute } from "@tanstack/react-router";
import EpisodesPlayerSkeleton from "@/modules/EpisodesPlayer/EpisodesPlayerSkeleton";
import { redirectSeriesDeeplink } from "@/lib/seriesDeeplink";

// Mobile deeplink, current format `/series-player?id={id}` and its mixed
// spelling `/series-player/{id}` — hence the optional path param.
export const Route = createFileRoute("/_videoPlayer/series-player/{-$id}")({
  loader: ({ params, location }) =>
    redirectSeriesDeeplink(location.search, { pathId: params.id }),
  pendingMs: 0,
  pendingMinMs: 0,
  pendingComponent: EpisodesPlayerSkeleton,
});
